// Scroll-in animation: removes `.init` from elements when they cross a threshold from viewport bottom.
// Threshold per element via class: .d_0 / .d_50 / .d_100 (default) / .d_200.
// Required CSS: define .init { opacity: 0; transform: ... } and the un-init transition.
export function initScrollEffect() {
  const elements = Array.from(document.querySelectorAll('.init'));
  if (!elements.length) return;

  const isSmall = () => window.innerWidth < 569;
  const thresholdFor = (el) => {
    const small = isSmall();
    if (el.classList.contains('d_200')) return small ? 100 : 200;
    if (el.classList.contains('d_50'))  return small ? 30  : 50;
    if (el.classList.contains('d_0'))   return 0;
    return small ? 50 : 100; // d_100 / default
  };

  const items = elements.map((el) => ({
    el,
    done: false,
    threshold: thresholdFor(el),
    top: el.getBoundingClientRect().top + window.scrollY,
  }));

  const recalc = () => {
    items.forEach((it) => {
      if (it.done) return;
      it.threshold = thresholdFor(it.el);
      it.top = it.el.getBoundingClientRect().top + window.scrollY;
    });
  };

  const tick = () => {
    const wh = window.innerHeight;
    const sy = window.scrollY;
    let any = false;
    items.forEach((it) => {
      if (it.done) return;
      if (sy > it.top - wh + it.threshold) {
        it.el.classList.remove('init');
        it.done = true;
        any = true;
      }
    });
    if (any) recalc();
  };

  window.addEventListener('scroll', tick, { passive: true });
  window.addEventListener('resize', recalc, { passive: true });
  // 初期チェック（ファーストビュー内のものは即解除）
  tick();
}

// Browser quirk fix: scroll 1px on load to nudge sticky/lazy elements into recalc.
export function nudgeScrollOnLoad() {
  window.addEventListener('load', () => {
    window.scrollBy(0, 1);
  });
}
